module.exports = __webpack_public_path__ + "img/tag2.2a361c14.png";